import { render, staticRenderFns } from "./Bulletinboardinfo.vue?vue&type=template&id=25c2714c&scoped=true&"
import script from "./Bulletinboardinfo.vue?vue&type=script&lang=js&"
export * from "./Bulletinboardinfo.vue?vue&type=script&lang=js&"
import style0 from "./Bulletinboardinfo.vue?vue&type=style&index=0&id=25c2714c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c2714c",
  null
  
)

export default component.exports